<template>
    <!-- bred crumb section start -->
    <section class="bred-crumb lg:pt-[8rem] pt-[6rem] pb-[2rem]">
    </section>
    <!-- bred crumb section end -->
    <!-- game page card prop up start -->
    <section
      class="sm:pt-[60px] pt-12 lg:pb-[100px] md:pb-20 sm:pb-16 pb-12 bg-nu2"
    >
      <div class="container">
        <div class="">
          <div
            class="sm:pb-10 pb-6 flex justify-between globl max-xl:flex-wrap"
          >
            <div class="flex max-lg:flex-wrap" data-aos="fade-right">
              <div class="lg:w-auto w-full pt-[6px]">
                <h4 class="text-nu9 pr-3">Filter by:</h4>
              </div>
              <div class="flex max-lg:flex-wrap lg:pt-0 pt-2">
                <div class="sm:pt-0 pt-3">
                  <button
                    class="tab-btn px-6 py-2 ml-1 bg-nu7 font-semibold text-nu1 rounded-full"
                    :class="gameType == 'all' ? 'active' : ''"
                    content-id="All"
                    @click="gameType = 'all'"
                  >
                    All
                  </button>
                </div>
                <div class="sm:pt-0 pt-3">
                  <button
                    class="tab-btn px-4 py-2 ml-1 bg-nu7 font-semibold text-nu1 rounded-full flex items-center"
                    content-id="Slots"
                    :class="gameType == 'Slots' ? 'active' : ''"
                    @click="gameType = 'Slots'"
                  >
                    <span class="pr-2"><PhHexagon class="text-secondary" size="1rem" weight="fill" /></span>
                    Slots
                  </button>
                </div>
                <div class="sm:pt-0 pt-3">
                  <button
                    class="tab-btn px-4 py-2 ml-1 bg-nu7 font-semibold text-nu1 rounded-full flex items-center"
                    content-id="Flight"
                    :class="gameType == 'Flight' ? 'active' : ''"
                    @click="gameType = 'Flight'"
                  >
                    <span class="pr-2"><PhHexagon class="text-secondary" size="1rem" weight="fill" /></span>
                    Flight
                  </button>
                </div>
                <div class="sm:pt-0 pt-3">
                  <button
                    class="tab-btn px-4 py-2 ml-1 bg-nu7 font-semibold text-nu1 rounded-full flex items-center"
                    content-id="Multiplayer"
                    :class="gameType == 'Multiplayer' ? 'active' : ''"
                    @click="gameType = 'Multiplayer'"
                  >
                    <span class="pr-2"><PhHexagon class="text-secondary" size="1rem" weight="fill" /></span>
                    Multiplayer
                  </button>
                </div>
                <div class="sm:pt-0 pt-3">
                  <button
                    class="tab-btn px-4 py-2 ml-1 bg-nu7 font-semibold text-nu1 rounded-full flex items-center"
                    content-id="Skill"
                    :class="gameType == 'Skill' ? 'active' : ''"
                    @click="gameType = 'Skill'"
                  >
                    <span class="pr-2"><PhHexagon class="text-secondary" size="1rem" weight="fill" /></span>
                    Skill
                  </button>
                </div>
                <div class="sm:pt-0 pt-3">
                  <button
                    class="tab-btn px-4 py-2 ml-1 bg-nu7 font-semibold text-nu1 rounded-full flex items-center"
                    content-id="Fishing"
                    :class="gameType == 'fishing' ? 'active' : ''"
                    @click="gameType = 'fishing'"
                  >
                    <span class="pr-2"><PhHexagon class="text-secondary" size="1rem" weight="fill" /></span>
                    Fishing
                  </button>
                </div>
              </div>
            </div>
            <div class="" data-aos="fade-left">
              <form
                class="flex px-2 xl:mt-0 mt-4 rounded-full bg-nu7"
              >
                <input
                  type="text"
                  v-model="gameName"
                  placeholder="Search"
                  class="placeholder:text-nu1 xl:w-[170px] w-[200px] text-nu1 border-none outline-none"
                />
                <button disabled>
                  <PhMagnifyingGlass class="text-primary" size="24" weight="bold" />
                </button>
              </form>
            </div>
          </div>
          <div class="tab-contents">
            <div class="content show" id="All">
              <div class="content-info w-full">
                <div class="grid grid-cols-12 gap-4">
                  <Game v-for="game in currGames" :key="game.id" :game="game"></Game>
                </div>
              </div>
            </div>
          </div>
          <!-- button -->
          <div
            class="flex justify-center gap-2 md:pt-[50px] sm:pt-8 pt-4 bg-nu2"
            data-aos="fade-right"
          >
            <button class="size-10 duration-500 rounded-full" @click="currPage -= 1" :disabled="currPage == 1">
              <PhCaretLeft class="text-primary" size="24" weight="bold" />
            </button>
            <template v-for="page in pageList">
              <button v-if="page > 0"
                class="sm:px-[12px] size-10 hover:bg-primary duration-500 text-nu1 rounded-full hover:text-ft"
                :class="currPage == page ? 'bg-primary text-ft' : ''"
                @click="currPage = page"
              >
                {{ page }}
              </button>
              <button v-else class="sm:px-[17px] text-nu1 pt-2 size-10 rounded-full">
                ...
              </button>
            </template>
            <button class="size-10 duration-500 rounded-full" @click="currPage += 1" :disabled="pageList.length == 0 || currPage == pageList[pageList.length - 1]">
              <PhCaretRight class="text-primary" size="24" weight="bold" />
            </button>
          </div>
        </div>
      </div>
    </section>
</template>

<script setup>
  import gameJson from '~~/static/data/game.json';
  import AOS from 'aos';
  import { PhCaretLeft, PhCaretRight, PhHexagon, PhMagnifyingGlass } from "@phosphor-icons/vue";
  const gameType = ref('all');
  const gameName = ref('');
  const currPage = ref(1);
  const pageSize = ref(4);
  const filteredGames = computed(() => {
    if (gameName.value) {
      return gameJson.games.filter((game) => {
        return game.title.toLowerCase().includes(gameName.value.toLowerCase());
      });
    }
    if (gameType.value === 'all') {
      return gameJson.games;
    }
    return gameJson.games.filter((game) => {
      return game.type === gameType.value;
    });
  })
  const currGames = computed(() => {
    const start = (currPage.value - 1) * pageSize.value;
    const end = start + pageSize.value;
    return filteredGames.value.slice(start, end);
  })
  // 计算出当前要显示的页码列表，首页和尾页一定会显示(如果只有一页的时候，只显示首页)
  // 如果超过5个页码, 显示首页, 0, 中间三页, 0, 尾页
  // 0的页码，就显示成省略号
  const pageList = computed(() => {
    const totalPage = Math.ceil(filteredGames.value.length / pageSize.value);
    if (totalPage <= 5) {
      return Array.from({ length: totalPage }, (_, index) => index + 1);
    }
    if (currPage.value <= 3) {
      return [1, 2, 3, 4, 0, totalPage];
    }
    if (currPage.value >= totalPage - 2) {
      return [1, 0, totalPage - 3, totalPage - 2, totalPage - 1, totalPage];
    }
    return [1, 0, currPage.value - 1, currPage.value, currPage.value + 1, 0, totalPage];
  });

  // 页面激活后，需要初始化aos
  onMounted(() => {
    AOS.init({
      duration: 2000,
      delay: 5000,
      once: true,
    });
  });

  // 如果切换了游戏类型，需要重置页码
  watch(gameType, () => {
    currPage.value = 1;
  });
</script>

<script>
  export default {
    name: 'Game',
  }
</script>
  